import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { faCheck, faTrash, faPen } from '@fortawesome/free-solid-svg-icons';
import { map, Observable } from 'rxjs';
import { MotoresTransmissaoTimeTableModel } from 'src/app/models/MotoresTransmissaoTimeTable';
import { MotoresTransmissaoService } from 'src/app/services/motores-transmissao/motores-transmissao.service';

@Component({
  selector: 'app-motores-transmissao-time-table',
  templateUrl: './motores-transmissao-time-table.component.html',
  styleUrls: ['./motores-transmissao-time-table.component.css'],
})
export class MotoresTransmissaoTimeTableComponent implements OnInit {

  faTrash = faTrash
  faPen = faPen
  faCheck = faCheck

  @Input() mode: 'selection' | 'edit' = 'edit';
  @Input() toggle: boolean = false;

  @Output() toggleChange = new EventEmitter<boolean>();
  @Output() rowSelected = new EventEmitter<any>();

  tripToEdit!: MotoresTransmissaoTimeTableModel | null;
  data$ = new Observable<MotoresTransmissaoTimeTableModel[]>()

  isLoading: boolean = false;
  showForm: boolean = false

  constructor(private readonly motoresTransmissaoService: MotoresTransmissaoService) {
  }

  ngOnInit() {
    this.loadMotoresTransmissaoTimeTable()
  }

  loadMotoresTransmissaoTimeTable() {
    this.isLoading = true
    this.data$ = this.motoresTransmissaoService.getAllTrips()
    this.isLoading = false;
  }

  deleteTrip(tripId: number, tripName: string) {
    if (confirm(`Deseja realmente excluir a viagem: ${tripName}?`)) {
      this.motoresTransmissaoService.deleteTrip(tripId).subscribe({
        next: _ => {
          alert("Viagem excluída com sucesso");
          this.data$ = this.data$.pipe(
            map(response => response.filter(r => r.id !== tripId)));
        },
        error: _ => {
          alert("Erro ao excluir a viagem");
        },
      });
    }
  }

  openEditForm(trip: any) {
    this.showForm = true
    this.tripToEdit = trip
  }

  onToggleClick(event: MouseEvent | KeyboardEvent) {
    event.stopPropagation();
    this.toggleChange.emit(false);
    this.toggle = !this.toggle;
  }

  toggleForm() {
    this.showForm = !this.showForm
    if (!this.showForm) {
      this.tripToEdit = null
    }
  }

  onSelectRow(data: any, event: MouseEvent) {
    event.stopPropagation();
    this.rowSelected.emit(data);
    this.toggle = !this.toggle
  }

  onDataUpdated() {
    this.loadMotoresTransmissaoTimeTable()
    this.showForm = false
    this.tripToEdit = null
  }
}
